import { designSystem } from '@/styles/theme';
import { FORM_COLOR } from '@/pages/Seminar/components/form/formStyles';

/**
 * 댓글·좋아요 줄 공용 색 — 속닥속닥·전문가 라운지 상세가 같은 값을 쓴다(2026-10-03 B안·D안 확정 시안 값).
 * 빨강은 UI 가이드의 한 가지(#E11D48)만 쓴다.
 */
export const COMMENT_COLOR = {
    /** 본문 아래 줄·댓글 사이 구분선 */
    line: '#E5E7EB',
    /** 답글 사이 구분선 */
    lineSoft: '#F1F3F2',
    /** 본문 아래 줄 글자 */
    barText: '#4B5563',
    /** 댓글 본문 */
    text: '#1F2937',
    /** 날짜·좋아요·답글 달기·메뉴 아이콘 */
    faint: '#9CA3AF',
    /** 답글 꺾은 화살표 */
    arrow: '#C4CAC8',
    /** 좋아요 누름 */
    liked: FORM_COLOR.danger,
    /** 브랜드 청록 — @닉네임·답글 더보기·작성자 표시 글자 */
    primary: designSystem.colors.primary,
    /** 작성자 표시 바탕 */
    primarySoft: FORM_COLOR.primarySoft,
    /** 누르는 칸 눌림 바탕 */
    hover: '#F3F4F6',
} as const;
